import {Component, Inject, OnInit, Optional} from '@angular/core';
import {Lookup} from '../../../_model/Lookup';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {LookupService} from '../../../_services/lookup.service';
import {ToastrService} from 'ngx-toastr';
import {forkJoin} from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-lookup-delete',
  templateUrl: './lookupdelete.component.html',
  styleUrls: ['./lookupdelete.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class LookupDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LookupDeleteComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: Lookup,
              private lookupService: LookupService,
              private toastr: ToastrService) { }

  ngOnInit() {
  }

  deleteLookup(lookup: Lookup) {
      this.lookupService.deleteLookup(lookup).subscribe(result => {
          this.lookupService.listLookups().subscribe(allLookupsResponse => {
              localStorage.setItem('lookupList', JSON.stringify(allLookupsResponse.responseData.items));
              this.toastr.success('Silme işlemi başarılı', '');
              this.dialogRef.close(allLookupsResponse.responseData.items);
              });
      }, error => {
          this.toastr.error(error.error.msg, 'Hata');
          this.dialogRef.close();
      });
  }

}
